import {FieldArray, FormikErrors} from 'formik'
import {isEmpty} from 'lodash'
import {ChangeEvent, useEffect} from 'react'
import FormInputMediaManager from 'src/cms/helpers/components/forms/FormInputMediaManager'
import FormTextBox from 'src/cms/helpers/components/forms/FormTextBox'
import {imageBaseUrl} from 'src/cms/helpers/constants'

interface Props {
  handleChange: (e: ChangeEvent<any>) => void
  errors: FormikErrors<{[key: string]: string}> | any
  touched: any
  values: {[key: string]: string} | any
  editSelectedData: {[key: string]: string} | any
  setFieldValue: any
}

export function IconDataSection({
  handleChange,
  errors,
  touched,
  values,
  editSelectedData,
  setFieldValue,
}: Props) {
  useEffect(() => {
    if (values.iconData.length < 1) {
      setFieldValue('iconData', [{image: '', title: '', order: ''}])
    }
  }, [values.iconData])
  return (
    <>
      <div className=''>
        <div className='row'>
          <div className='row'>
            <FieldArray
              name='iconData'
              render={(arrayHelpers) => (
                <div>
                  <h5 className='rs-modal-title mb-5'>Icon Data</h5>
                  {values.iconData && values.iconData.length > 0
                    ? values.iconData.map((icon: any, index: any) => (
                        <div className='row mb-4' key={index}>
                          <div className='col-md-6 col-xs-12'>
                            <FormTextBox
                              type='number'
                              placeholder='Order'
                              name={`iconData[${index}].order`}
                              label='Order'
                              labelClassName='col-md-12'
                              containerClassName='col-md-12'
                              onChange={handleChange}
                              errors={errors}
                              touched={touched}
                            />
                          </div>
                          <div className='col-md-6 col-xs-12'>
                            <FormTextBox
                              type='text'
                              placeholder='Title'
                              name={`iconData[${index}].title`}
                              label='Text (EN)'
                              labelClassName='col-md-12'
                              containerClassName='col-md-12'
                              onChange={handleChange}
                              errors={errors}
                              touched={touched}
                            />
                          </div>
                          <div className='col-md-6 col-xs-12'>
                            <FormInputMediaManager
                              labelClassName='col-md-12'
                              containerClassName='col-md-12'
                              label='Attached File'
                              name={`iconData[${index}].image`}
                              setFieldValue={setFieldValue}
                              value={values?.attachedFile}
                              required
                              showImageOnly={true}
                            />
                            {!isEmpty(icon?.image) ? (
                              <>
                                <li className='listing'>
                                  <div className='thumbImageBlock'>
                                    <button
                                      type='button'
                                      title='Remove'
                                      className='btn thumbImage-remove d-flex align-items-center justify-content-center btn-primary'
                                      onClick={() => {
                                        setFieldValue(`iconData[${index}].image`, '')
                                      }}
                                      data-cy='modal-thumbnail-remove'
                                    >
                                      X
                                    </button>

                                    <img
                                      className='thumbImage w-100 h-100'
                                      src={`${imageBaseUrl}/${icon?.image}`}
                                      alt='image'
                                    />
                                  </div>
                                </li>
                              </>
                            ) : null}
                          </div>

                          {index > 0 && (
                            <div className='col-md-6 col-sm-6 col-xs-12 justify-content-md-end text-end mb-2'>
                              <button
                                type='button'
                                className='p-2 ps-5 pe-5 btn btn-secondary'
                                onClick={() => arrayHelpers.remove(index)}
                                data-cy='modal-field-remove'
                              >
                                Remove
                              </button>
                            </div>
                          )}
                        </div>
                      ))
                    : null}

                  {values.iconData[values.iconData.length - 1]?.image && (
                    <div className=' d-flex justify-content-md-end mb-2 border-top border-light pt-5'>
                      <button
                        className='p-2 ps-5 pe-5 btn btn-primary'
                        type='button'
                        onClick={() =>
                          arrayHelpers.push({
                            title: '',
                            image: '',
                          })
                        }
                        data-cy='modal-field-add'
                      >
                        + Add More
                      </button>
                    </div>
                  )}
                </div>
              )}
            />
          </div>
        </div>
      </div>
    </>
  )
}
